// Small helper to format fiat and crypto amounts for display
export function formatFiat(amount, currencySymbol = '₦') {
  if (amount === undefined || amount === null || amount === '') return '';
  const num = Number(amount);
  if (Number.isNaN(num)) return '';
  return `${currencySymbol}${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function defaultCryptoDecimals(symbol) {
  const s = (symbol || '').toUpperCase();
  if (s === 'BTC' || s === 'LTC' || s === 'BCH') return 4;
  if (s === 'ETH' || s === 'ADA' || s === 'SOL') return 6;
  if (s === 'USDT' || s === 'USDC') return 2;
  return 6;
}

export function formatCrypto(amount, symbol, decimals) {
  if (amount === undefined || amount === null || amount === '') return '';
  const num = Number(amount);
  if (Number.isNaN(num)) return '';
  const d = typeof decimals === 'number' ? decimals : defaultCryptoDecimals(symbol);
  // fixed with trimming trailing zeros
  let s = num.toFixed(d);
  s = s.replace(/\.0+$|(?<=[0-9])0+$/u, match => match.replace(/0+$/u, '') );
  // remove trailing dot if any
  s = s.replace(/\.$/, '');
  return s;
}

export function formatFiatCryptoPair(fiatAmount, cryptoAmount, cryptoSymbol) {
  const f = formatFiat(fiatAmount);
  const c = formatCrypto(cryptoAmount, cryptoSymbol);
  if (f && c && cryptoSymbol) return `${f} (${c} ${cryptoSymbol})`;
  if (f && c) return `${f} (${c})`;
  if (f) return f;
  if (c && cryptoSymbol) return `${c} ${cryptoSymbol}`;
  return '';
}

export default { formatFiat, formatCrypto, formatFiatCryptoPair };
